// Local libary
import { UnsubscribeObservableService, TranslatePipe } from '@amwager/util';

// Angular libray
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// Third party
import { Subscription, takeUntil } from 'rxjs';

// Local library
import { DepositCryptoCurrencyService } from '@amwager/funding/data-access';

// from JS eProtect iFrame CDN
// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let bitpay: any; // class

@Component({
  selector: 'feature-mat-crypto-currency',
  templateUrl: './crypto-currency.component.html',
  styleUrls: ['./crypto-currency.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslatePipe
  ],
  standalone: true,
  providers: [DepositCryptoCurrencyService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CryptoCurrencyComponent extends UnsubscribeObservableService implements OnInit {

  cryptoCurrencyForm!: FormGroup;

  // convenience getter for easy access to form fields
  get formVal() { return this.cryptoCurrencyForm?.controls }

  amount!: number;

  private subsDepositCryptoCurrencyResponse!: Subscription;

  isDepositing = false;

  isOnline: boolean = true;

  constructor(
    private readonly cdRef: ChangeDetectorRef,
    private readonly cryptoCurrencyService: DepositCryptoCurrencyService,
  ) {
    super();
  }

  ngOnInit() {
    this.checkConnectivity();
    this.loadBitPayScript();

    // OLD (moved to DepositCryptoCurrencyService.buildForm):
    // this.initForm();
    this.cryptoCurrencyForm = this.cryptoCurrencyService.buildForm();
  }

  depositAmount(): void {
    this.amount = this.formVal['amount']?.value;
  }

  deposit(): void {
    if (!this.isOnline) {
      // OLD (moved to DepositCryptoCurrencyService.setOffline):
      // this.commonFacade.setIsConnectedInternet('CryptoCurrencyComponent:deposit', false);
      this.cryptoCurrencyService.setOffline('CryptoCurrencyComponent:deposit');
      return;
    }

    if (this.cryptoCurrencyForm.valid && this.amount) {
      this.isDepositing = true;

      // OLD (dispatch + success stream moved to DepositCryptoCurrencyService.deposit$):
      // this.fundingFacade.depositCryptoCurrency(this.amount);
      // this.subsDepositCryptoCurrencyResponse = this.fundingFacade.isDepositCryptoCurrencySuccess$()
      this.subsDepositCryptoCurrencyResponse = this.cryptoCurrencyService.deposit$(this.amount)
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe(({response, isSuccess}) => {
        if (!isSuccess && response !== undefined) {
          this.showAlertMessage('Deposit Error', response.error.Message);
          this.isDepositing = false;
          this.cdRef.markForCheck();
        }

        this.subsDepositCryptoCurrencyResponse?.unsubscribe();

        if (isSuccess) {
          if (bitpay && bitpay.showInvoice) {
            this.openLink(response.InvoiceID);
          }

          this.isDepositing = false;
          this.cdRef.markForCheck();
        }
      });
    }
    else {
      // OLD (moved to DepositCryptoCurrencyService.markFormGroupTouched):
      // this.fundingService.markFormGroupTouched(this.cryptoCurrencyForm);
      this.cryptoCurrencyService.markFormGroupTouched(this.cryptoCurrencyForm);
    }
  }

  loadBitPayScript(): void {
    // OLD (script load + logging moved to DepositCryptoCurrencyService.loadBitPayScript):
    // this.removeBitPayScript();
    // const scriptsToAdd = [{ id: 'bitPay', url: this.BIT_PAY_URL }];
    // this.loadService.addScripts(scriptsToAdd).then(...).catch(...);
    this.cryptoCurrencyService.loadBitPayScript().finally(() => this.cdRef.markForCheck());
  }

  removeBitPayScript(): void {
    // OLD (script removal + logging moved to DepositCryptoCurrencyService.removeBitPayScript):
    // const scriptsToRemove = ['bitPay'];
    // this.loadService.removeScripts(scriptsToRemove).then(...).catch(...);
    this.cryptoCurrencyService.removeBitPayScript().finally(() => this.cdRef.markForCheck());
  }

  openLink(invoiceId: string): void {
    // OLD (moved to DepositCryptoCurrencyService.openInvoice):
    // this.fundingService.openCryptoInvoice(invoiceId);
    this.cryptoCurrencyService.openInvoice(invoiceId);
  }

  showAlertMessage(header: string, message: string): void {
    // OLD (moved to DepositCryptoCurrencyService.showAlert):
    // this.matNotificationService.showAlert(header, message, undefined, undefined, 'Close');
    this.cryptoCurrencyService.showAlert(header, message);
  }

  checkConnectivity(): void {
    // OLD (moved to DepositCryptoCurrencyService.checkConnectivity):
    // this.fundingService.checkConnectivity(
    //   this.environment,
    //   'CryptoCurrencyComponent:checkConnectivity',
    //   (online: boolean) => this.isOnline = online
    // );
    this.cryptoCurrencyService.checkConnectivity(
      'CryptoCurrencyComponent:checkConnectivity',
      (online: boolean) => this.isOnline = online
    );
  }

}
